import { Component, Input } from '@angular/core'
import { Andamento } from 'src/app/models/andamento'
import { DownloadService } from 'src/app/services/download.service'
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { ConcursoAndamento } from 'src/app/models/concurso-andamento'
import { ConcursoService } from 'src/app/services/concurso.service'
import { Meta } from '@angular/platform-browser'
import { ToastService } from '../../toast/services/toast.service'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-informacao-adicional',
  templateUrl: './informacao-adicional.component.html',
  styleUrls: ['./informacao-adicional.component.css'],
})
export class InformacaoAdicionalComponent {
  @Input() andamentos?: Andamento[] = []
  @Input() id?: number = 0
  @Input() idConcurso?: number = 0
  @Input() collapsed: boolean = false
  @Input() area?: string
  @Input() departamento?: string
  @Input() disciplinas?: string
  tamanho: number = 0

  concursoAndamento?: ConcursoAndamento
  loading: boolean = true
  i18n = {
    atencao: '',
    urlInvalida: '',
  }

  constructor(
    private readonly concursoService: ConcursoService,
    private readonly downloadService: DownloadService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location,
    private readonly meta: Meta,
    private readonly toastService: ToastService,
    private readonly translateService: TranslateService
  ) {}

  open(id: number, idConcurso: number): void {
    if (id == null) {
      this.downloadService.edital(idConcurso)
    } else {
      this.downloadService.andamento(id)
    }
  }

  ordenacaoAndamentos(andamentos: Andamento[] | undefined): Andamento[] | undefined {
    if (andamentos) {
      this.tamanho = andamentos.length
      for (let i = 0; i < this.tamanho; i++) {
        for (let j = 0; j < this.tamanho - i - 1; j++) {
          if (Date.parse(andamentos[j].data) > Date.parse(andamentos[j + 1].data)) {
            let temp = andamentos[j]
            andamentos[j] = andamentos[j + 1]
            andamentos[j + 1] = temp
          }
        }
      }
    }
    return andamentos
  }

  ngOnInit(): void {
    this.carregarI18n()
    this.translateService.onLangChange.subscribe(() => {
      this.carregarI18n()
    })

    this.route.params.subscribe(async params => {
      this.id = Number(params['id'])
      let caracteresEspeciais = params['id'].replace(/[\d\s]/g, '')

      if (this.id && typeof this.id === 'number' && Number.isInteger(this.id) && caracteresEspeciais.length == 0) {
        this.concursoService.get(this.id).subscribe(obj => {
          if (obj) {
            this.meta.updateTag({ name: 'description', content: obj.titulo })
            this.concursoAndamento = obj
            this.loading = false
          } else {
            setTimeout(() => {
              this.router.navigate(['/concurso/inscricao-aberta'])
            }, 2000)
          }
        })
      } else {
        this.toastService.showErrorToast(this.i18n.atencao, this.i18n.urlInvalida)
        setTimeout(() => {
          this.voltar()
        }, 2000)
      }
    })
  }

  voltar(): void {
    this.location.back()
  }

  edital(): void {
    this.downloadService.edital(this.concursoAndamento?.id ?? 0)
  }

  private carregarI18n(): void {
    this.translateService.get(['shared.atencao', 'concurso.url_invalida']).subscribe(traducoes => {
      this.i18n.atencao = traducoes['shared.atencao']
      this.i18n.urlInvalida = traducoes['concurso.url_invalida']
    })
  }

  hasInformacaoAdicional(): boolean | undefined {
    return this.andamentos?.some(item => item.tipo === 'COMUNICADO')
  }
}
